// src/Hooks/useTransmitFreeViewEmail.ts
import { useCallback, useRef, useState } from "react";
import { transmitFreeviewEmail, EnsureFreeviewResponse } from "../../Api/Brevo";

export function useTransmitFreeViewEmail() {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | undefined>(undefined);
    const [data, setData] = useState<EnsureFreeviewResponse | undefined>(undefined);

    // Keep one controller per hook instance; abort on re-submit.
    const controllerRef = useRef<AbortController | null>(null);

    const submit = useCallback(async (email: string) => {
        // Abort any in-flight request
        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;

        setIsLoading(true);
        setError(undefined);
        setData(undefined);

        try {
            const resp = await transmitFreeviewEmail(controller, email);
            setData(resp);
            return resp;
        } catch (e: any) {
            // Ignore abort errors as “not real failures”
            if (e?.name === "AbortError") return;
            setError(e?.message || "request_failed");
            throw e;
        } finally {
            setIsLoading(false);
        }
    }, []);

    const abort = useCallback(() => {
        controllerRef.current?.abort();
    }, []);

    return { submit, abort, isLoading, error, data };
}
